var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("insurer-list-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.insurerSummaries, function (insurer, index) {
                      return _c(
                        "tr",
                        {
                          key: insurer.insurerId,
                          class: { "is-selected": _vm.selectedRow === index },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.generateUrl(insurer.insurerId),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.edit(insurer.insurerId, $event)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(insurer.name))]
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(insurer.suburb))]),
                          _c("td", [_vm._v(_vm._s(insurer.labourType))]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _vm._v(_vm._s(insurer.ecomTypeName)),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _c(
                              "span",
                              {
                                staticClass: "tag",
                                class: [
                                  insurer.quotingMethod === "D"
                                    ? "is-success"
                                    : "is-info",
                                ],
                              },
                              [_vm._v(_vm._s(insurer.quotingMethod))]
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _c(
                              "span",
                              {
                                staticClass: "icon",
                                class: [
                                  insurer.active
                                    ? "has-text-success"
                                    : "has-text-danger",
                                ],
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-24px",
                                  class: [
                                    insurer.active ? "mdi-check" : "mdi-close",
                                  ],
                                }),
                              ]
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-primary is-small is-inverted tooltip",
                                attrs: {
                                  href: _vm.generateUrl(insurer.insurerId),
                                  "data-tooltip": "Click to edit",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.edit(insurer.insurerId, $event)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-medium" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-lead-pencil mdi-24px",
                                  }),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }